@if (isLoading) {
  <div class="loading-container">
    <mat-spinner></mat-spinner>
  </div>
}

@if (!isLoading && projects.data.length === 0) {
  <div class="empty-message" i18n>Der Nutzer hat keine Projekte.</div>
}

<div class="table-wrapper" [dtOverlayProgress]="isDownloading">
  <table [class.hidden]="projects.data?.length === 0" mat-table [dataSource]="projects" matSort>
    <ng-container matColumnDef="projectType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n></th>
      <td mat-cell *matCellDef="let project">
        @if (project.projectType === 'team') {
          <mat-icon [color]="'primary'"> groups </mat-icon>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
      <td mat-cell *matCellDef="let project">
        <span class="project-info">
          <span data-cy="project-name">{{ project.name }}</span>
          @if (isTeamProject(project)) {
            <span class="text" data-cy="member-role" i18n>{{ project.userMemberRole | teamMemberRole }}</span>
          }
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Aktualisiert am</th>
      <td mat-cell *matCellDef="let project">{{ project.updatedAt | date: 'medium' }}</td>
    </ng-container>
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Erstellt am</th>
      <td mat-cell *matCellDef="let project">{{ project.createdAt | date: 'medium' }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let project">
        <button
          mat-icon-button
          (click)="downloadProject(project)"
          [disabled]="isDownloading"
          matTooltip="Projekt herunterladen"
          i18n-matTooltip
          ><mat-icon>download</mat-icon></button
        >
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
